import { FunctionComponent, MouseEvent } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

interface InfoButtonProps {
  onClick?: (e: MouseEvent<HTMLButtonElement>) => any;
  className?: string;
}

const InfoButton: FunctionComponent<InfoButtonProps> = ({
  onClick = undefined,
  className = "",
}) => {
  return (
    <button
      tabIndex={0}
      aria-label={"Plus d'informations"}
      onClick={onClick}
      className={`button-info ${className}`}
    >
      <InfoCircleOutlined />
    </button>
  );
};

export default InfoButton;
